import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["panel", "overlay"]

  open() {
    this.panelTarget.classList.add("active")
    this.overlayTarget.classList.add("active")
  }

  close() {
    this.panelTarget.classList.remove("active")
    this.overlayTarget.classList.remove("active")
  }

  connect() {
    this.escapeHandler = (e) => {
      if (e.key === "Escape") this.close()
    }

    document.addEventListener("keydown", this.escapeHandler)
  }

  disconnect() {
    document.removeEventListener("keydown", this.escapeHandler)
  }
}